import React, { useState, useEffect } from "react";
import { LeadViewDetailsViewAttachmentInfoProps } from "./lead-view-details-view-attachment-info.props";
import UploadDropDown from "./upload-dropdown";
import "./lead-view-details-view-attachment-info.scss";
import UploadFileAttachment from "./upload-file-attachment";
import UploadLinkUrlAttachment from "./upload-link-url-attachment";
import ListAttachMents from "./list-attachments";
import { getAttachments } from "../../../../../../api/lead";
import { AlertComponent } from "../../../../../../common/components";

const LeadViewDetailsViewAttachmentInfo: React.FC<
  LeadViewDetailsViewAttachmentInfoProps
> = ({ setLoading, leadId, disableEdit, permissions,leadDetails }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [attachmentsList, setAttachmentsList] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");

  const handleOptionChange = (e: any) => {
    setSelectedOption(e.target.value);
  };

  const fetchAttachments = async () => {
    setLoading(true);
    try {
      const response = await getAttachments(leadId);
      setAttachmentsList(response?.data?.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message || "Failed to get lead attachments."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    fetchAttachments();
  }, [leadId]);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  return (
    <div className="lead-list-view-details-view-box-attachment-info">
      <div className="lead-list-view-details-view-box-attachment-info-header">
        <div className="lead-list-view-details-view-box-attachment-info-header-text">
          Attachments
        </div>
        <div>
          <UploadDropDown
            selectedOption={selectedOption}
            handleChange={handleOptionChange}
            disableEdit={disableEdit || !permissions?.canWrite||leadDetails?.lead_status === "Closed-Won"}
          />
          <UploadFileAttachment
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            leadId={leadId}
            setLoading={setLoading}
            fetchAttachments={fetchAttachments}
          />
          <UploadLinkUrlAttachment
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            leadId={leadId}
            setLoading={setLoading}
            fetchAttachments={fetchAttachments}
          />
        </div>
      </div>
      {attachmentsList?.length > 0 ? (
        <div className="lead-list-view-details-view-box-attachment-info-list">
          <ListAttachMents
            leadId={leadId}
            attachmentsList={attachmentsList}
            fetchAttachments={fetchAttachments}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            disableEdit={disableEdit || !permissions?.canWrite||leadDetails?.lead_status === "Closed-Won"}
          />
        </div>
      ) : (
        <div className="lead-list-view-details-view-box-attachment-info-no-data">
          No Attachments
        </div>
      )}
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default LeadViewDetailsViewAttachmentInfo;
